import { render, staticRenderFns } from "./ExpertList.vue?vue&type=template&id=a8669010"
import script from "./ExpertList.vue?vue&type=script&lang=js"
export * from "./ExpertList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports